module.exports = __webpack_public_path__ + "static/media/2018_0716_18491700-01.ff6b2fa2.jpg";